const DROP_MODAL_COMPONENT = 'modalContainer/loanApplication',
  DROP_MODAL_EVENT_ACTION = 'modalLoanApplication';

export { DROP_MODAL_COMPONENT, DROP_MODAL_EVENT_ACTION };
